module.exports = __webpack_public_path__ + "assets/202509252035/img/qp.de6bdbe0.jpg";